;(function() {
  'use strict'

  Controller.$inject = ["glUtils", "$state", "breadcrumbsService", "creditPromotionService", "glToast", "clipboardService"];
  angular.module('app.core').controller('Promotions', Controller)

  /* @ngInject */
  function Controller(
    glUtils,
    $state,
    breadcrumbsService,
    creditPromotionService,
    glToast,
    clipboardService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isVisible = isVisible
    ctrl.updateFilterParams = updateFilterParams
    ctrl.orderBy = orderBy
    ctrl.copyToClipboard = clipboardService.copy

    var Statuses = {
      ANY: null,
      ACTIVE: 'active',
      PENDING: 'pending',
      EXHAUSTED: 'exhausted',
      EXPIRED: 'expired',
      DISABLED: 'disabled',
    }
    ctrl.statusOptions = [
      { label: 'Any', value: Statuses.ANY },
      { label: 'Pending', value: Statuses.PENDING },
      { label: 'Active', value: Statuses.ACTIVE },
      { label: 'Exhausted', value: Statuses.EXHAUSTED },
      { label: 'Expired', value: Statuses.EXPIRED },
      { label: 'Disabled', value: Statuses.DISABLED },
    ]

    function onInit() {
      var query = $state.params.query
      var status = $state.params.status
      ctrl.Statuses = Statuses
      ctrl.filter = {
        query: query || '',
        status: status || Statuses.ANY,
      }
      breadcrumbsService.addBreadcrumb('Promotions', 'home')
      ctrl.loading = true
      creditPromotionService
        .list()
        .then(function(promotions) {
          ctrl.promotions = promotions
          ctrl.loading = false
        })
        .catch(function(e) {
          glToast.show('Could not load promotions.')
          ctrl.loading = false
        })
    }

    function updateFilterParams() {
      glUtils.changeParams({
        query: ctrl.filter.query,
        status: ctrl.filter.status,
      })
    }

    function isVisible(promotion) {
      var query = ctrl.filter.query
      var queryLower = query.toLowerCase()
      var status = ctrl.filter.status

      var queryMatch = query
        ? promotion.id === query ||
          promotion.name.toLowerCase().includes(queryLower) ||
          promotion.description.toLowerCase().includes(queryLower) ||
          (promotion.subscriberId &&
            promotion.subscriberId.toLowerCase().includes(queryLower)) ||
          (promotion.subscriberEmail &&
            promotion.subscriberEmail.toLowerCase().includes(queryLower)) ||
          (promotion.createdById &&
            promotion.createdById.toLowerCase().includes(queryLower)) ||
          (promotion.createdByEmail &&
            promotion.createdByEmail.toLowerCase().includes(queryLower)) ||
          promotion.codePrefix.toLowerCase().includes(queryLower) ||
          promotion.subscriptionCode.toLowerCase().includes(queryLower) ||
          (promotion.hubspotId &&
            promotion.hubspotId.toLowerCase().includes(queryLower))
        : true

      var statusMatch = false
      if (status === null || status === promotion.status) {
        statusMatch = true
      }

      return queryMatch && statusMatch
    }

    function orderBy(promotion) {
      return promotion.createdAt.unix()
    }
  }
})()
